import React from 'react';
import PropTypes from 'prop-types';
import { Alert, AlertTitle } from '@mui/material';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, errorInfo: null };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      error,
      errorInfo,
    });
    // Можно также сохранить информацию об ошибке в соответствующую службу журнала ошибок
  }

  render() {
    const { errorInfo, error } = this.state;
    const { children } = this.props;

    if (errorInfo) {
      // Error path
      return (
        <Alert
          icon={false}
          severity="error"
          onClose={() => this.setState({
            error: null,
            errorInfo: null,
          })}
          style={{ alignItems: 'flex-start' }}
        >
          <AlertTitle>
            При виконанні останньої дії виникла помилка.
          </AlertTitle>

          <details style={{ whiteSpace: 'pre-wrap', color: 'red' }}>
            {error && error.toString()}
            <br />
            {errorInfo.componentStack}
          </details>
        </Alert>
      );
    }
    return children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node,
};

ErrorBoundary.defaultProps = {
  children: null,
};

export default ErrorBoundary;
